import { ContentTypeEnum } from "~/types/enum/ContentTypeEnum";
import { ContentTextEditorType } from "~/types/blog/content/ContentTextEditorType";
import { RuntimeConfig } from "nuxt/schema";

export const contentAutoMapper = (ctx: object, config: RuntimeConfig) => {
    switch (ctx?.__component) {
        case ContentTypeEnum.TextEditor:
            return contentTextEditorMapper(ctx);
        case ContentTypeEnum.TitleMediumTextAndRightImage:
            return contentTitleMediumTextAndRightImageMapper(ctx, config);
    }

    return null;
}

export const contentTextEditorMapper = (ctx: object) => {
    return <ContentTextEditorType>{
        type: ctx?.__component,
        text: ctx.text,
    };
}

export const contentTitleMediumTextAndRightImageMapper = (ctx: object, config: RuntimeConfig) => {
    return <ContentTextEditorType>{
        type: ctx?.__component,
        smallTitle: ctx?.small_title,
        bigTitle: ctx?.big_title,
        text: ctx?.text,
        image: config.public.mediaBaseUrl + ctx?.image?.data?.attributes?.url,
    };
}